import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import { Prop } from "vue-property-decorator";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "ShippingAddressList" })
export default class ShippingAddressList extends Vue {
    public localizer: any = Localizer;
    public shippingAddress: any = null;
    public isEditAddress: boolean = false;
    public isLoading: boolean = true;
    public isLoadingForm: boolean = false;
    public shippingAddresses: any[] = [];
    public validationErrors: any[] = [];

    @Prop() readonly shippingMode: string;

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly countries: any;
    @Prop() readonly provinces: any;

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.isLoading = true;

        this.shippingAddresses = (await Axios.post(this.routes.AccountShippingAddress_GetShippingAddresses)).data;
        for (const shipping of this.shippingAddresses) {
            shipping.zone = shipping.country === "IT" ? this.provinces.find(x => x.value === shipping.zone).title : shipping.zone;
            shipping.country = this.countries.find(x => x.value === shipping.country).title;
        }

        this.isLoading = false;
    }

    public async controlEdit(value: any) {
        this.$emit("isEditAddress", value);
        this.isEditAddress = value;

        await this.getData();
    }

    public newAddress(address: any) {
        this.shippingAddress = address;
        this.isEditAddress = true;
        this.$emit("isEditAddress", true);
    }

    public removeAddressDialog(address: any) {
        if (confirm(this.localizer.get("Checkout.Common.Shipping_Delete_Address"))) {
            this.removeAddress(address);
        }
    }

    public async removeAddress(address: any) {
        this.isLoadingForm = true;
        this.validationErrors = [];

        try {
            await Axios.post(this.routes.AccountShippingAddress_DeleteShippingAddress, address);

            await this.getData();
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoadingForm = false;
    }

    public async setDefaultAddress(address: any) {
        this.isLoadingForm = true;
        this.validationErrors = [];

        try {
            await Axios.post(this.routes.AccountShippingAddress_SetDefaultShippingAddress, address);

            await this.getData();
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoadingForm = false;
    }
};